import * as angular from 'angular';
import * as wtFramework from '../../wtFramework';

import { ComponentDefinition } from '../../models/';
import { IGroupDependencyService } from '../../services/';

class GroupDependentsController implements angular.IComponentController {
    configuration: any;
    groupGuid: string;
    isCreating: boolean;
    isLoading: boolean;
    data: any = [];
    prefix = 'dependents';

    static $inject = ['groupDependencyService', '$state', '$translate'];

    constructor(
        private _groupDependencyService: IGroupDependencyService,
        private _$state: angular.ui.IStateService,
        private _$translate: angular.translate.ITranslateService) {
    }

    $onInit() {
        this.configuration = {
            childrenCallback: d => d.dependentList,
            direction: wtFramework.DependencyDirection.TopToBottom,
            clickCallback: d => this._$state.go('group.general', { groupGuid: d.guid }),
            nameCallback: d => d.uniqueName,
            initialLevel: 2,
            labels: { expand: this._$translate.instant('Expand'), collapse: this._$translate.instant('Collapse') }
        };
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        if (onChangesObj['groupGuid'] && this.groupGuid) {
            if (!this.isCreating) {
                this.isLoading = true;
                this._groupDependencyService
                    .getDependents(this.groupGuid)
                    .then(data => this.data = data)
                    .finally(() => this.isLoading = false);
            }
        }
    }
}

export const wtGroupDependents: ComponentDefinition = {
    componentId: 'wtGroupDependents',
    controller: GroupDependentsController,
    template: require('./groupDependencies.component.html'),
    controllerAs: 'vm',
    bindings: {
        groupGuid: '<',
        isCreating: '<'
    }
};
